import evaluationResultLabelTermsService from "presentation/services/evaluation-result-label-terms";


// Timesheet Structure Items methods
// Carrega um item no state
export const loadEvaluationResultLabelTerm = (key, component) => {
    const { evaluationResultLabelTerms } = component.state;
    let output = undefined;

    if (evaluationResultLabelTerms.length > 0) {
        var item = evaluationResultLabelTerms.find(x => { return x.key == key });
        output = item !== undefined ? item : undefined;
    }

    return output;
}

// Monta a lista no state
export const mountItems = (component) => {

    const { totalItems, evaluationResultLabelTerms } = component.state;

    const deleteRequested = evaluationResultLabelTerms.filter(x => x.isDeleteRequested === true);

    let newEvaluationResultLabelTerms = [];

    for (let i = 0; i < totalItems; i++) {

        let itemKey = i + 1;

        //Default values

        let defaultItemName = '';
        let defaultRangeStart = undefined;
        let defaultRangeEnd = undefined;
        let defaultItemId = null;
        let defaultParentId = null;

        let itemName = defaultItemName;
        let itemRangeStart = defaultRangeStart;
        let itemRangeEnd = defaultRangeEnd;
        let itemId = defaultItemId;
        let itemParentId = defaultParentId;

        let evaluationResultLabelTerm = loadEvaluationResultLabelTerm(itemKey, component);

        if (evaluationResultLabelTerm !== undefined) {
            itemName = evaluationResultLabelTerm['name'] || defaultItemName;
            itemRangeStart = evaluationResultLabelTerm['numericRangeStart'] || itemRangeStart;
            itemRangeEnd = evaluationResultLabelTerm['numericRangeEnd'] || itemRangeEnd;
            itemId = evaluationResultLabelTerm['id'] || defaultItemId;
            itemParentId = evaluationResultLabelTerm['evaluationResultLabelId'] || defaultParentId;
        }

        newEvaluationResultLabelTerms.push({
            key: itemKey,
            id: itemId,
            evaluationResultLabelId: itemParentId,
            name: itemName,
            numericRangeStart: itemRangeStart,
            numericRangeEnd: itemRangeEnd,
            orderNumber: i
        });
    }

    let finalEvaluationResultLabelTerms = [...newEvaluationResultLabelTerms, ...deleteRequested];

    component.setState({ evaluationResultLabelTerms: finalEvaluationResultLabelTerms });
}

//Carrega as informações de um campo específico do item no state
export const evaluationResultLabelTermsFormValue = (key, formField, component) => {

    let output = undefined;

    var item = loadEvaluationResultLabelTerm(key, component);

    output = item !== undefined ? item[formField] : undefined;

    return output;

}

//Tratativas para quando um campo muda de valor (geral)
export const handleChangeEvaluationResultLabelTerms = (key, event, component) => {
    const { value, checked, type } = event.target;

    const name = event.target.getAttribute('data-field-name');

    const changeValue = type == "checkbox" ? checked : value;

    handleFieldChange(key, name, changeValue, component);
}


//Método genérico para acompanhar tratativas de mudança de valor dos campos
export const handleFieldChange = (key, field, value, component) => {
    var item = loadEvaluationResultLabelTerm(key, component);

    item[field] = value;

    const newEvaluationResultLabelTerms = changeEvaluationResultLabelTermsList(component, item);

    let finalOptions = beforeChangeEvaluationResultLabelTermsState(key, field, value, newEvaluationResultLabelTerms, component);

    component.setState({
        evaluationResultLabelTerms: finalOptions
    });
}

//Método para executar tratamentos antes da mudança para o novo state do formulário
export const beforeChangeEvaluationResultLabelTermsState = (key, changedField, changeValue, newEvaluationResultLabelTerms, component) => {
    const { form } = component.state;
    let output = newEvaluationResultLabelTerms;

    return output;
}

//Prapara o objeto do state para a atualização com as informações das alternativas da questão
export const changeEvaluationResultLabelTermsList = (component, targetOption, remove = false) => {
    let { evaluationResultLabelTerms } = component.state;

    let optionIndex = evaluationResultLabelTerms.findIndex(option => option.key == targetOption.key);

    if (remove === true) {
        let elementId = evaluationResultLabelTerms[optionIndex]['id'] || undefined;

        if (elementId) {
            evaluationResultLabelTerms[optionIndex]['isDeleteRequested'] = true;
            evaluationResultLabelTerms[optionIndex]['key'] = 'delete-requested-' + new Date().getTime();
        } else {
            evaluationResultLabelTerms.splice(optionIndex, 1);
        }
    } else {
        evaluationResultLabelTerms[optionIndex] = targetOption;
    }

    return evaluationResultLabelTerms;
}


//Prepara as requisições para administrar as alternativas das questões
export const prepareItemsRequests = (evaluationResultLabelEntity, evaluationResultLabelTermsData) => {
    let promises = undefined;
    let requests = [];
    evaluationResultLabelTermsData.map((e, index) => {

        let postData = {
            evaluationResultLabelId: evaluationResultLabelEntity.id
        };

        if (e.id) {
            postData.id = e.id;
            postData.insertAt = e.insertAt;

            if (e.isDeleteRequested) {
                postData.isDeleteRequested = true;
            }
        }
        postData = {
            ...postData,
            name: e.name,
            numericRangeStart: e.numericRangeStart,
            numericRangeEnd: e.numericRangeEnd,
            order: e.orderNumber
        }

        requests.push(postData);

    });

    if (requests.length > 0) {
        promises = requests.map(async (element, index) => {
            //Salva os dados da progressão
            if (element['isDeleteRequested']) {
                await evaluationResultLabelTermsService.remove(element['id']);
            } else {
                await evaluationResultLabelTermsService.save(element);
            }
        });
    };

    return promises;

}


const evaluationResultLabelTermsFunctions = {
    prepareItemsRequests,
    loadEvaluationResultLabelTerm,
    evaluationResultLabelTermsFormValue,
    handleChangeEvaluationResultLabelTerms,
    beforeChangeEvaluationResultLabelTermsState,
    changeEvaluationResultLabelTermsList,
    mountItems
}

export default evaluationResultLabelTermsFunctions;